import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["index", "value", "selected"]

import { ref } from "vue";
import DbSelect from "../DB-Components/DbSelect.vue";

type LengthToTypeOptions = {
  [key: number]: string[];
};

export default /*@__PURE__*/_defineComponent({
  __name: 'OrderContainerTypeInput',
  props: {
  modelValue: {
    type: String,
    required: true,
  },
  lengthRestriction: {
    type: Number,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  ariainvalid: {
    type: Boolean,
    default: false,
    required: false,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;
// set options to conditionally generate based on input length
let lengthsToTypes = ref<LengthToTypeOptions>({
  20: ["BOX", "WB", "TANK", "HC", "OTOP", "REEF", "FLAT", "HARDTP", "BULK"],
  21: ["BOX", "WB", "TANK", "HC", "OTOP", "REEF", "FLAT", "HARDTP", "BULK"],
  22: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  23: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  24: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  26: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  30: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  31: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  35: ["BOX", "WB"],
  40: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  42: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  44: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  45: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  60: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  81: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  82: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  84: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  85: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  86: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  91: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  94: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  96: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  97: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  10: ["SANH"],
});
// an object that maps each number to a list of possible types (keywords)

let options = ref<string[]>(lengthsToTypes.value[props.lengthRestriction]);
let selected = ref(options.value.indexOf(props.modelValue));
const emit = __emit;

const handleInput = (event: HTMLInputElement) => {
  let target = event.target as HTMLInputElement;
  emit("update:modelValue", target.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DbSelect, {
    modelValue: _unref(selected),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selected) ? (selected).value = $event : selected = $event)),
    value: _unref(selected),
    onChange: handleInput,
    disabled: __props.disabled,
    ariainvalid: __props.ariainvalid,
    class: "w-full hydrated",
    name: "height"
  }, {
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("option", { select: "" }, null, -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(options), (containerType, index) => {
        return (_openBlock(), _createElementBlock("option", {
          key: index,
          index: index,
          value: _unref(options)[index],
          selected: index === _unref(selected)
        }, _toDisplayString(_ctx.$t(`order.containerType.${_unref(options)[index]}`)), 9, _hoisted_1))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue", "value", "disabled", "ariainvalid"]))
}
}

})